import { useLanguage } from "@/contexts/LanguageContext";

export default function Security() {
  const { t } = useLanguage();

  return (
    <section id="sicurezza" className="py-20 px-6 border-b border-white/10 max-w-6xl mx-auto" data-testid="security-section">
      <div className="grid md:grid-cols-12 gap-8 items-center">
        <div
          className="md:col-span-5 rounded border border-[#E2C079]/30 p-8 relative overflow-hidden"
          style={{ background: "radial-gradient(80% 80% at 30% 30%, #581222 0%, #0b131e 100%)" }}
          data-testid="security-cert-card"
        >
          <div className="text-[#E2C079] font-mono-code text-xs uppercase tracking-widest mb-2">{t.security.eyebrow}</div>
          <div className="text-2xl font-serif-didot text-white mb-4">{t.security.cert}</div>
          <p className="text-xs text-white/70 leading-relaxed">{t.security.certText}</p>
        </div>
        <div className="md:col-span-7 space-y-4">
          <h2 className="font-serif-didot text-2xl sm:text-3xl text-white">{t.security.title}</h2>
          <p className="text-sm text-white/70 leading-relaxed">{t.security.text}</p>
          <div className="pt-2 flex flex-wrap gap-4 text-xs font-mono-code text-[#E2C079]">
            {t.security.badges.map((b, i) => (
              <span key={b} className="px-3 py-1 bg-white/5 border border-white/10" data-testid={`security-badge-${i}`}>
                {b}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
